import { tv } from '@ui/tv';

/**
 * How the Framer loader tilts the dashboard; with `translate-y-(--welcome-shift)`
 * it sits where the loader shows it. The layout computes the numbers for the
 * window size (`loaderPose`) into these custom properties.
 */
const LOADER_TILT =
  'scale-(--welcome-scale) [transform:perspective(var(--welcome-perspective))_rotateX(40deg)]';

/**
 * The app shell during the welcome reveal: hidden while it loads, then shown
 * tilted below the message as in the Framer loader; on entering it flips up
 * from there into place. The flat pose keeps the same transform functions
 * (rotateX 0) so the browser interpolates the tilt, and matches no
 * transform at all once the reveal ends.
 */
export const welcomeShellVariants = tv({
  base: 'flex min-h-0 flex-1 relative lg:static origin-center',
  variants: {
    phase: {
      none: '',
      // hidden, a little below its place; no transition, so it starts
      // hidden however it was first styled
      loading: `${LOADER_TILT} translate-y-[calc(var(--welcome-shift)+24px)] opacity-0 transition-none will-change-[translate,opacity]`,
      // eases in: slowly at first, so it fades rather than pops up
      preview: `${LOADER_TILT} translate-y-(--welcome-shift) opacity-100 transition-[translate,opacity] duration-1200 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none will-change-[translate,opacity]`,
      entering:
        'translate-y-0 scale-100 [transform:perspective(var(--welcome-perspective))_rotateX(0deg)] opacity-100 transition-[translate,scale,transform,opacity] duration-1500 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none will-change-[translate,scale,transform]',
    },
  },
  defaultVariants: {
    phase: 'none',
  },
});
